// Copyright (c) Microsoft. All rights reserved.

import { Dispatch, MiddlewareAPI, configureStore } from '@reduxjs/toolkit';
import { AppState } from '../features/app/AppState';
import { ConversationsState } from '../features/conversations/ConversationsState';
import { signalRMiddleware } from '../features/message-relay/signalRMiddleware';
import { UsersState } from '../features/users/UsersState';
import resetStateReducer, { resetApp } from './rootReducer';
import { HostContextState } from '../features/hostContext/hostContextState';
import { AnnouncementsState } from '../features/announcements/announcementsState';
import { EscalationOfferState } from '../features/livechat/escalationOfferSlice';
import { AgentTypingState } from '../features/livechat/agentTypingSlice';
import { ScreenshotRequestState } from '../features/livechat/screenshotRequestSlice';

export type StoreMiddlewareAPI = MiddlewareAPI<Dispatch, RootState>;
export const store = configureStore({
    reducer: resetStateReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(signalRMiddleware),
});
export type AppStore = typeof store;

export interface RootState {
    app: AppState;
    conversations: ConversationsState;
    users: UsersState;
    hostContext: HostContextState;
    announcements: AnnouncementsState;
    escalationOffer: EscalationOfferState;
    agentTyping: AgentTypingState;
    screenshotRequest: ScreenshotRequestState;
}

export const getSelectedChatID = (): string => {
    return store.getState().conversations.selectedId;
};

export type AppDispatch = typeof store.dispatch;

// Function to reset the app state
export const resetState = () => {
    store.dispatch(resetApp());
};
